var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-content"},[_c('ud-empty-row',{attrs:{"height":_vm.height}}),_c('img',{staticClass:"empty-content-image",attrs:{"src":_vm.pic,"mode":"widthFix"}}),_c('ud-empty-row',{attrs:{"height":"48"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }